import { Button } from '@mui/material'
import React from 'react'
import { BiError } from 'react-icons/bi';

export const Error500 = () => {
    return (
        <div className="bg-white dark:bg-blue-cole-dark-surface p-6 rounded-lg shadow-lg w-full mx-auto">
            <div className="bg-red-100 text-red-500 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto">
                <BiError size={32} />
            </div>
            <h2 className="mt-6 text-xl font-bold text-gray-800 dark:text-white text-center">
                ¡Ups! Algo salió mal.
            </h2>
            <p className="mt-4 text-sm text-gray-600 dark:text-ink-muted-dark text-center">
                Lo sentimos, ha ocurrido un error en el servidor. Nuestro equipo ha sido notificado y estamos trabajando para solucionarlo.
            </p>
            <p className="mt-4 text-xs text-gray-500 dark:text-ink-muted-dark text-center">
                Si el problema persiste, por favor contacta a nuestro soporte técnico.
            </p>
        </div>
    )
}
